var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import BubbleTrigger from "./components/BubbleTrigger/BubbleTrigger";
import Frame from "./components/Frame/Frame";
import { useDispatch, useSelector } from "react-redux";
import { currentLanguage, interactWithChatBot, isChatMinimized, minimizeChat } from "./stores/reducers/chatReducer";
import chatBotApi from "../bubble/api/chatbot";
import { KEYBOARD_NAVIGATION_ORDER_BOTTOM, KEYBOARD_NAVIGATION_ORDER_TOP } from "./constants/setting";
var Index = function () {
    var dispatch = useDispatch();
    var isMinimized = useSelector(isChatMinimized);
    var language = useSelector(currentLanguage);
    var _b = useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _j = useState(false), isEnabledChatbots = _j[0], setIsEnabledChatbots = _j[1];
    var toggleTrigger = function () {
        dispatch(interactWithChatBot());
        dispatch(minimizeChat(null));
        triggerPushState(!isMinimized);
    };
    var isMobile = function () {
        return window.innerWidth < 469 || window.innerHeight < 469;
    };
    var triggerPushState = function (isMinimized) {
        if (isMobile()) {
            // @ts-ignore
            var url = new URL(window.location);
            history.pushState({
                isMinimized: isMinimized
            }, 'minimizeChat', url);
        }
    };
    window.onpopstate = function (event) {
        if (isMobile()) {
            if (event.state && event.state.hasOwnProperty('isMinimized')) {
                dispatch(minimizeChat(event.state.isMinimized));
            }
            else if (!isMinimized) {
                dispatch(minimizeChat(true));
            }
        }
    };
    var getFurthestParentElement = function (element) {
        var currentElement = element;
        while (currentElement.parentNode && currentElement.parentNode !== document.body && currentElement.parentNode !== document.documentElement) {
            currentElement = currentElement.parentNode;
        }
        return currentElement;
    };
    var repositionChatbotElement = function (position) {
        if (position === void 0) { position = KEYBOARD_NAVIGATION_ORDER_BOTTOM; }
        var chatBotEl = document.getElementById('alwayson_chatbot');
        if (position === KEYBOARD_NAVIGATION_ORDER_TOP && chatBotEl) {
            var bodyElement = document.body;
            var firstATag = bodyElement === null || bodyElement === void 0 ? void 0 : bodyElement.querySelector('a');
            if (!firstATag) {
                bodyElement.insertBefore(chatBotEl, bodyElement.firstChild);
            }
            else {
                var parentElement = getFurthestParentElement(firstATag);
                if (parentElement) {
                    parentElement.after(chatBotEl);
                }
            }
        }
    };
    var escFunction = function (event) {
        if (event.key === "Escape") {
            dispatch(minimizeChat(true));
        }
    };
    var prepareAlwaysonChatbotLoaded = function () {
        // @ts-ignore
        if ((window === null || window === void 0 ? void 0 : window.alwaysonChatbotLoaded) && typeof alwaysonChatbotLoaded === 'function') {
            // @ts-ignore
            window === null || window === void 0 ? void 0 : window.alwaysonChatbotLoaded();
        }
    };
    useEffect(function () {
        document.addEventListener("keydown", escFunction, false);
        prepareAlwaysonChatbotLoaded();
    }, []);
    var init = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, chatBotApi.getBotSetting(language).then(function (response) {
                        var _b, _j;
                        window.alwayson_settings = response.data || {};
                        repositionChatbotElement(response.data.keyboard_navigation_order);
                        setIsEnabledChatbots(((_b = response.data) === null || _b === void 0 ? void 0 : _b.enable_chatbots) && !((_j = response.data) === null || _j === void 0 ? void 0 : _j.is_disabled));
                        setIsLoading(false);
                    }).catch(function (err) {
                        var _b, _j;
                        console.error((_j = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _j === void 0 ? void 0 : _j.message);
                        console.error(err.response.status === 404 ? 'Invalid chatbot id' : 'something went wrong!');
                    })];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var receiveMessage = function (event) {
        if (event.data === 'minimize_chat') {
            dispatch(minimizeChat(true));
        }
        // Do something with the received data
        //console.log("Received message from iframe:", event.data);
    };
    useEffect(function () {
        // Function to handle messages from the iframe
        // Register the message event listener
        window.addEventListener("message", receiveMessage, false);
    }, []);
    useEffect(function () {
        init();
        if (isMobile()) {
            dispatch(minimizeChat(true));
        }
    }, []);
    return !isLoading && isEnabledChatbots ? _jsxs(_Fragment, { children: [_jsx(BubbleTrigger, { onClickCallback: toggleTrigger }), _jsx(Frame, { isMinimized: isMinimized, onClickMinimize: toggleTrigger })] }) : null;
};
export default Index;
